import { addMonths, format } from 'date-fns';
import { useEffect, useState } from 'react';
import { API_ENDPOINTS, buildApiUrl } from '../config/api';

/**
 * Días cerrados (yyyy-MM-dd) configurados desde el admin: no se puede recoger ni devolver ese día.
 * Si la petición falla se devuelve un Set vacío; el backend vuelve a validar al crear la reserva.
 */
export const useClosedDays = () => {
  const [closedDays, setClosedDays] = useState(() => new Set());

  useEffect(() => {
    let cancelled = false;
    const from = format(new Date(), 'yyyy-MM-dd');
    const to = format(addMonths(new Date(), 18), 'yyyy-MM-dd');

    (async () => {
      try {
        const response = await fetch(buildApiUrl(`${API_ENDPOINTS.CLOSED_DAYS}?from=${from}&to=${to}`));
        if (!response.ok) throw new Error(`Error ${response.status}`);
        const data = await response.json();
        if (!cancelled && data.success) {
          setClosedDays(new Set((data.data || []).map((d) => d.date)));
        }
      } catch (err) {
        console.error('Error fetching closed days:', err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { closedDays };
};
